import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["options", "fieldName", "input"];

  connect() {
    if (this.hasInputTarget && this.inputTarget.type === "checkbox") {
      this._getCheckedUnchecked();
    } else if (this.hasInputTarget && this.inputTarget.type === "radio") {
      this._getSelectedRadio();
    }

    this._getSelectedChanged();
  }

  showOptions() {
    if (this.optionsTarget.getAttribute("collapsed") === "") {
      this.optionsTarget.removeAttribute("collapsed");
    } else {
      this.optionsTarget.setAttribute("collapsed", "");
    }
  }

  _getCheckedUnchecked() {
    let selectedOptions = [];

    this.inputTargets.forEach((checkbox) => {
      checkbox.addEventListener("change", (event) => {
        const option = event.target.id;
        if (event.target.checked) {
          selectedOptions.push(option);
        } else {
          selectedOptions.splice(selectedOptions.indexOf(option), 1);
        }

        // Dispatch event with selected options that can be listened to by other controllers.
        const selectedOptionsEvent = new CustomEvent("selectedOptionsChanged", {
          detail: {
            allSelectedOptions: selectedOptions,
            currentOption: { option: option, checked: event.target.checked },
            id: this.element.id,
          },
        });
        document.dispatchEvent(selectedOptionsEvent);
      });
    });
  }

  _getSelectedRadio() {
    const radios = this.optionsTarget.querySelectorAll(".option-radio");
    let selectedOption;

    radios.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        const option = event.target.nextElementSibling.innerText;
        if (event.target.checked) {
          selectedOption = option;
        }

        this._setFieldName(selectedOption ? 1 : 0, selectedOption);

        // Dispatch event with selected options that can be listened to by other controllers.
        const selectedOptionsEvent = new CustomEvent("selectedOptionsChanged", {
          detail: {
            allSelectedOptions: selectedOption ? [selectedOption] : [],
            currentOption: { option: option, checked: event.target.checked },
            id: this.element.id,
          },
        });
        document.dispatchEvent(selectedOptionsEvent);
      });
    });
  }

  _getSelectedChanged() {
    document.addEventListener("removeTagClicked", ({ detail: { tag, _selectedTags } }) => {
      document.getElementById(tag).checked = false;
    });
  }
}
